// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Software Risk Management application registration.
 */
import { registerApplication } from '../../core/layout-registry'
import { SrmUserView } from './components/UserView'
import { SrmAdminView } from './components/AdminView'
import './renderer-components/register'

registerApplication({
  id: 'srm',
  name: 'Software Risk Management',
  description: 'Three-track compliance review for software procurement',
  components: [
    {
      id: 'applications/srm',
      label: 'Software Risk Management',
      icon: 'ShieldCheck',
      category: 'application',
      description: 'Privacy, security, and accessibility review dashboard',
      order: 30,
      Component: SrmUserView,
      ConfigComponent: SrmAdminView,
    },
  ],
})
